/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SoftwareAudienceTeam
 */
export interface SoftwareAudienceTeam {
  /**
   *
   * @type {string}
   * @memberof SoftwareAudienceTeam
   */
  teamId: string;
  /**
   *
   * @type {string}
   * @memberof SoftwareAudienceTeam
   */
  name: string;
}

/**
 * Check if a given object implements the SoftwareAudienceTeam interface.
 */
export function instanceOfSoftwareAudienceTeam(
  value: object,
): value is SoftwareAudienceTeam {
  if (!("teamId" in value) || value["teamId"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function SoftwareAudienceTeamFromJSON(json: any): SoftwareAudienceTeam {
  return SoftwareAudienceTeamFromJSONTyped(json, false);
}

export function SoftwareAudienceTeamFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SoftwareAudienceTeam {
  if (json == null) {
    return json;
  }
  return {
    teamId: json["teamId"],
    name: json["name"],
  };
}

export function SoftwareAudienceTeamToJSON(json: any): SoftwareAudienceTeam {
  return SoftwareAudienceTeamToJSONTyped(json, false);
}

export function SoftwareAudienceTeamToJSONTyped(
  value?: SoftwareAudienceTeam | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamId: value["teamId"],
    name: value["name"],
  };
}
